module.exports = __webpack_public_path__ + "img/status5.cee06dfb.svg";